/**
 * Format an amount with a currency code.
 * Uses Intl so any ISO 4217 code works (cad, usd, dop, eur, …).
 */
export const displayCurrency = (currency: string, amount: number) => {
  if (!currency) {
    return null;
  }

  try {
    const format = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency.toUpperCase(),
      useGrouping: false,
    }).format(Number(amount));

    return format.replace(/[A-Za-z ]/g, "");
  } catch {
    return null;
  }
};
